import * as types from './chart.types';
export const chartPageSelectors: types.IChartPageSelectors = {
  selectNodes: (state) => state.page.chart.nodeIds,
  selectRefreshChart: (state) => state.page.chart.refreshChart,
  selectChartVersions: (state) => state.page.chart.versions,
  selectSelectedChartId: (state) => state.page.chart.selectedChartId,
  selectIsDraftSelected: (state) => state.page.chart.isDraftSelected,
};
